import { render, staticRenderFns } from "./FeatureCard.vue?vue&type=template&id=dae3c194&scoped=true&"
import script from "./FeatureCard.vue?vue&type=script&lang=ts&"
export * from "./FeatureCard.vue?vue&type=script&lang=ts&"
import style0 from "./FeatureCard.vue?vue&type=style&index=0&id=dae3c194&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dae3c194",
  null
  
)

export default component.exports